import { ModalCustom } from "components/ModalCustom";
import { FaCheck } from "react-icons/fa";

interface IProps {
  show: boolean;
  idLote: number | null;
  onClose: () => void;
}

export function ModalSucessoCriarLote({ show, idLote, onClose }: IProps) {
  return (
    <ModalCustom
      show={show}
      handleClose={onClose}
      title="Lote criado"
      centered
    >
      <div style={{ textAlign: "center", padding: "8px 0" }}>
        <div
          style={{
            width: 56,
            height: 56,
            borderRadius: 16,
            background: "#e6f9f0",
            display: "inline-flex",
            alignItems: "center",
            justifyContent: "center",
            marginBottom: 12,
          }}
        >
          <FaCheck style={{ color: "#28a745", fontSize: "1.8rem" }} />
        </div>
        <p style={{ marginBottom: 4 }}>Lote de pagamento criado com sucesso!</p>
        {idLote && (
          <p style={{ fontWeight: "bold", marginBottom: 0 }}>ID Lote: {idLote}</p>
        )}
      </div>
    </ModalCustom>
  );
}
